import { PayloadAction } from '@reduxjs/toolkit';
import {
  IAccessRightsNumbers,
  ISimpleUser,
} from 'app/containers/User/slice/types';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { authorizationSaga } from './saga';
import {
  AuthorizationState,
  IGetUserCompanyPermissionsPayload,
  IPermissionsByCompany,
  IRegisterUser,
} from './types';

export const initialState: AuthorizationState = {
  user: null,
  envPermissions: {
    initLoaded: false,
    loading: false,
    permissionsArr: {
      companyAdministration: 0,
      cultureAdministration: 0,
      fieldAdministration: 0,
      resourceAdministration: 0,
      taskAdministration: 0,
      recommendationPermission: 0,
      usersAdministration: 0,
      garageAdministration: 0,
      analytics: 0,
    },
  },
  companyPermissions: {
    initLoaded: false,
    loading: false,
    permissionsArr: null,
  },

  initLoaded: false,
  registerLoading: false,

  permissionsByCompany: { analytics: [], recommendation: [] },
};

const slice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    setPermissionsByCompany(
      state,
      action: PayloadAction<IPermissionsByCompany>,
    ) {
      state.permissionsByCompany = action.payload;
    },

    resetPassword(state, action: PayloadAction<string>) {},
    initialLoad(state, action: PayloadAction) {},
    initialLoaded(state, action: PayloadAction<boolean>) {
      state.initLoaded = true;
    },

    getUserEnvPermissions(state, action: PayloadAction<number>) {},
    setUserEnvPermissions(state, action: PayloadAction<IAccessRightsNumbers>) {
      state.envPermissions.permissionsArr = action.payload;
      state.envPermissions.initLoaded = true;
    },
    setUserEnvPermissionsLoading(state, action: PayloadAction<boolean>) {
      state.envPermissions.loading = action.payload;
    },

    getUserCompanyPermissions(
      state,
      action: PayloadAction<IGetUserCompanyPermissionsPayload>,
    ) {},
    setUserCompanyPermissions(
      state,
      action: PayloadAction<IAccessRightsNumbers | null>,
    ) {
      state.companyPermissions.permissionsArr = action.payload;
      state.companyPermissions.initLoaded = true;
    },
    setUserCompanyPermissionsLoading(state, action: PayloadAction<boolean>) {
      state.companyPermissions.loading = action.payload;
    },

    setUser(state, action: PayloadAction<ISimpleUser>) {
      state.user = action.payload;
    },
    registerUser(state, action: PayloadAction<IRegisterUser>) {
      state.registerLoading = true;
    },
    setRegisterUserLoading(state, action: PayloadAction<boolean>) {
      state.registerLoading = action.payload;
    },
  },
});

export const { actions: authorizationActions } = slice;

export const useAuthorizationSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: authorizationSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useAuthorizationSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
